import { MutationTree, ActionTree, Module } from 'vuex';
import { RootState, AuthState } from './../types';

const state: AuthState = {
  authToken: localStorage.getItem('token') || undefined,
  tokenExp: localStorage.getItem('tokenExp') || 0,
  user: localStorage.getItem('user') || '',
  userGivenName: localStorage.getItem('userGivenName') || '',
  userFamilyName: localStorage.getItem('userFamilyName') || '',
  isAuthed: false,
  loading: false
};

const mutations: MutationTree <AuthState> = {
  // setAuthToken(authState, authToken: string) {
  //   authState.authToken = authToken;
  // },
  setTokenExp(authState, tokenExp: number) {
    authState.tokenExp = tokenExp;
  },
   setUser(authState, user: string) {
    authState.user = user;
  },
  setUserGivenName(authState, userGivenName: string) {
    authState.userGivenName = userGivenName;
  },
  setUserFamilyName(authState, userFamilyName: string) {
    authState.userFamilyName = userFamilyName;
  },
  setIsAuth(authState, isAuthed: boolean) {
    authState.isAuthed = isAuthed;
  },
  setLoading(state, value) {
    state.loading = value;
  }
};

const actions: ActionTree <AuthState, RootState> = {
  // onLogin({commit}, { token, exp }) {
  //   localStorage.setItem('token', token);
  //   if (exp) {
  //     localStorage.setItem('tokenExp', exp);
  //   } else {
  //     localStorage.removeItem('tokenExp');
  //   }
    
  //   commit('setAuthToken', token);
  //   commit('setTokenExp', exp);
  // },
   onLogin({commit}, { user,givenName,familyName, exp }) {
    console.log("____")
    localStorage.setItem('user', user);
    localStorage.setItem('userGivenName', givenName);
    localStorage.setItem('userFamilyName', familyName);
    if (exp) {
      localStorage.setItem('tokenExp', exp);
    } else {
      localStorage.removeItem('tokenExp');
    }
    
    // commit('setAuthToken', token);
    // commit('setTokenExp', exp);
    commit('setUser', user);
    commit('setUserGivenName', givenName);
    commit('setUserFamilyName', familyName);
    commit('setIsAuth', true);
  },
  onLogout({commit}, fromExpiry: boolean) {
    // localStorage.removeItem('token');
    // localStorage.removeItem('AUTH.TOKEN');
    // sessionStorage.removeItem('AUTH.TOKEN');
    
    // commit('setAuthToken', '');
    // commit('setTokenExp', 0);
    localStorage.removeItem('user');
    localStorage.removeItem('tokenExp');
    
    commit('setUser', '');
    commit('setUserGivenName', "");
    commit('setUserFamilyName', "");
    commit('setIsAuth', false);
    // if (fromExpiry) {
    //   location.reload();
    // }else{
    //   location.href = '/';
    // }
    location.href = '/splash';
  }
};

const getters = {
  loading: (state: AuthState) => state.loading,
}

export const auth: Module<AuthState, RootState> = {
  state,
  mutations,
  actions,
  getters

};
